/**
 * This class defines standard breakpoints for use in code without "magic numbers".
 * To use, import { Breakpoints } from 'base/js/templates/general/breakpoints.js'; (within common-ui) or
 * import { Breakpoints } from 'common-ui-frontend/src/main/webpack/base/js/templates/general/breakpoints.js';
 * from other projects.
 * Standard bootstrap breakpoints are used (xs, sm, md, lg, xl, xxl).
 * To get the minimum width of a breakpoint in pixels, use getBreakpoint(name) e.g. Breakpoints.getBreakpoint('md').
 * To get the maximum width of a breakpoint, use Breakpoints.getBreakpointMax('md') (or lg, xs, etc).
 * If you have any questions ask me (Andy) for help.
 */
class Breakpoints {

  static  breakpoints = {
    xs: 0, // Extra small devices (phones)
    sm: 576, // Small devices (tablets)
    md: 768, // Medium devices (desktops)
    lg: 992, // Large devices (large desktops)
    xl: 1200, // Extra large devices (large desktops)
    xxl: 1400 // Extra extra large devices
  };

  static breakpointsMax = {
    xs: 575, // Extra small devices (phones)
    sm: 767, // Small devices (tablets)
    md: 991, // Medium devices (desktops)
    lg: 1199, // Large devices (large desktops)
    xl: 1399, // Extra large devices (large desktops)
  };

  static getBreakpoint(name) {
    return this.breakpoints[name] || null;
  }

  static getBreakpointMax(name) {
    return this.breakpointsMax[name] || null;
  }

  /*
   * Compare that window.innerWidth is greater than or equal to the smallest width of the given breakpoint.
   */
  static isWiderThanOrEqual (breakpoint) {
    try {
      const bp = this.getBreakpoint(breakpoint);
      return window.innerWidth >= bp;
    }
    catch (e) {
      console.log(e);
    }
  }

  /*
   * Compare that window.innerWidth is less than the smallest width of the given breakpoint.
   */
  static isNarrowerThan (breakpoint) {
    try {
      const bp = this.getBreakpoint(breakpoint);
      return window.innerWidth < bp;
    }
    catch (e) {
      console.log(e);
    }
  }

}

export { Breakpoints };
